module.exports = __webpack_public_path__ + "media/images/icon-inquiry-mail-66d4deeb4c2492e1ece58a7d3f51af45.svg";